export const apiDomain = process.env.ROOT_API;
export const frontDomain = process.env.FRONT_ROOT_URL;
export const ssoDomain = process.env.SSO_ROOT_URL;




export const api_token = '';

export const getUsers = ssoDomain+"/api/getusers";
//export const getUsers = "https://sso.vtc.systems/api/getusers";

// export const baseurl=apiDomain + '/api/v1';
export const baseurl=apiDomain + '';
export const systemyear = baseurl + '/get/systemyear';
export const loginUser = baseurl + '/login';
export const logoutUser = baseurl + '/logout';
export const landingData = baseurl + '/get/dashboard';
export const importGLEport = baseurl + '/glexport/import';
export const importTopFacilityExport = baseurl + '/topfacilityexport/import';

export const getHeader = function () {

    // var tokenData = JSON.parse(window.localStorage.getItem('authUser'));
    var headers = {
        'Accept' : 'application/json',
        'Authorization': 'Bearer '+ window.localStorage.getItem('api_token'),
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Headers':'Origin, Content-Type, Authorization,X-Requested-With',
        "Cache-Control": "no-cache"
    }

    //console.log("headers",headers);
    return headers;
}
export const getCustHeader = function () {
    const headers = {
        'Accept' : 'application/json',
        'Authorization': window.localStorage.getItem('api_token'),
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Headers':'Origin, Content-Type, Authorization,X-Requested-With',
        "Cache-Control": "no-cache"
    }
    //console.log("headers",headers);
    return headers;
}




// WEBPACK FOOTER //
// ./src/config.js